module.exports = __webpack_public_path__ + "static/img/3712_phase_function_Paper_PointsHejduk_Prediction.3f67ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3712_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lueS
// module chunks = 0